import type {CouponTemplate} from '../../../../types';

import {GiftOutlined, LeftOutlined, TruckOutlined} from '@ant-design/icons';
import {cn} from '@ds/helpers';

type CouponTemplateItemProps = {
  template: CouponTemplate;
  hasBorder?: boolean;
  onSelect: (template: CouponTemplate) => void;
};

const CouponTemplateItem: React.FC<CouponTemplateItemProps> = ({
  template,
  hasBorder = true,
  onSelect
}) => {
  const icon =
    template.reward_mode === 'free_delivery' ? (
      <TruckOutlined aria-hidden />
    ) : (
      <GiftOutlined aria-hidden />
    );

  return (
    <button
      type="button"
      className="flex w-full items-center gap-4 px-4 pt-3 text-start focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange"
      onClick={() => onSelect(template)}
    >
      <span className="mb-3 shrink-0 text-heading-h4 text-gray-34">{icon}</span>
      <span
        className={cn(
          'flex min-w-0 flex-1 items-center gap-4 pb-3',
          hasBorder && 'border-b border-gray-22'
        )}
      >
        <span className="flex min-w-0 flex-1 flex-col">
          <span className="text-body-sm-emphasis text-neutral-fg">{template.title}</span>
          <span className="text-body-sm text-gray-34">شرط: {template.description}</span>
        </span>
        <LeftOutlined aria-hidden className="shrink-0 text-body-lg text-gray-29" />
      </span>
    </button>
  );
};

export default CouponTemplateItem;
